module.exports = __webpack_public_path__ + "icon-brand-recognition.svg?1922b68a4d1dce29b2c40904cdbc1bba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-brand-recognition.svg
// module id = 35
// module chunks = 0